import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import TeacherPanel from './TeacherPanel';
import StudentPanel from './StudentPanel';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
        {/* 顶部导航栏 */}
        <nav className="bg-white/80 backdrop-blur-md shadow-lg sticky top-0 z-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between h-16 items-center">
              <div className="flex items-center">
                <div className="flex-shrink-0 flex items-center gap-3">
                  <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-xl flex items-center justify-center text-white font-bold text-xl">
                    🧪
                  </div>
                  <span className="font-bold text-xl bg-clip-text text-transparent bg-gradient-to-r from-gray-800 to-blue-600">
                    高中化学 AI 课堂助手
                  </span>
                </div>
              </div>
              <div className="flex space-x-4">
                <Link 
                  to="/teacher" 
                  className="px-4 py-2 rounded-lg text-gray-600 hover:bg-blue-50 hover:text-blue-600 font-medium transition-all duration-200"
                >
                  老师控制台
                </Link>
                <Link 
                  to="/" 
                  className="px-4 py-2 rounded-lg bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-medium shadow-md hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-200"
                >
                  学生端
                </Link>
              </div>
            </div>
          </div>
        </nav>

        {/* 路由配置 */}
        <Routes>
          <Route path="/teacher" element={<TeacherPanel />} />
          <Route path="/" element={<StudentPanel />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;